import { useContext } from "react";

import { UiMetadataContext } from "../UiMetadataProvider";

export const useUiMetadataSetting = (key, defaultValue) => {
  const { uiMetadata } = useContext(UiMetadataContext);

  return uiMetadata?.[key] ?? defaultValue;
};
